import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import LineTitleGray from '../../atoms/titles/LineTitleGray';
import LinkButton from '../../atoms/button/LinkButton';
import Textlink from '../../atoms/link/Textlink';
import ModalMail from '../../modal/ModalMail';
import Loading from '../../atoms/Loading';
import { LAYOUT_TYPES, UNEXPECTED_ERROR_MESSAGE } from '../../../constants';
import { setLayoutType, setCurrentStep, setErrorMessages } from '../../../modules/app';
import { apiClient } from '../../../modules/apiClient';
import { getSessionId } from '../../../utils/localStorage';
import { getValidationErrorMessagesRest } from '../../../utils/error';

const Mail = () => {
  const [email, setEmail] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      setLayoutType(LAYOUT_TYPES.step)
    );
    dispatch(setCurrentStep(2));

    return () => {
      dispatch(
        setLayoutType(LAYOUT_TYPES.default)
      );
    };
  }, []);

  const history = useHistory();
  const handleAgree = () => {
    setLoading(true);
    setHasError(false);

    const sessionId = getSessionId();
    apiClient.postEmail(email, sessionId).then(() => {
      setLoading(false);
      setOpenModal(true);
    }).catch((error) => {
      if (error.response && error.response.data) {
        const messages = getValidationErrorMessagesRest(error.response.data);
        dispatch(setErrorMessages(messages));
        setHasError(true);
      } else {
        dispatch(setErrorMessages([UNEXPECTED_ERROR_MESSAGE]));
      }
      setLoading(false);
    });
  };

  const handleBack = () => {
    history.goBack();
  };

  const tripConditionUrl = 'http://rsv.nta.co.jp/F_Booking/static/ryokojoken_shusai.htm';

  return (
    <div className="mailPage">
      <Loading show={loading} hideProgressBar progressRate={100} />
      <LineTitleGray size="lg">会員登録せずに申し込み</LineTitleGray>
      <div className="mailPageInner">
        <p className="leadText">
      下記メールアドレス宛に、予約のためのURLをお送りいたします。
          <br />受信後、メール内のURLをクリックし、次へお進みください。
        </p>
        <div className="formInputArea">
          <div className="formInputTitle">メールアドレス</div>
          <div className="formInput">
            <input
              type="text"
              placeholder="nippon_travel@agency.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={hasError ? 'hasError' : undefined}
            />
            <div className="formInputSup">
          ※メールアドレスを間違えますと予約を続けられませんのでご注意ください。<br />
          ※メール受信制限をされている方は、「nta.co.jp」からのメールを受信できるように設定してから送信してください。
            </div>
          </div>
        </div>
        <div className="noteTexts">
          <div className="checkIcon">
            <img src="/dpp/img/icons/checkRed.svg" alt="" />
          </div>
          <div className="noteTextBody">
            <p className="noteTextTitle">会員登録しないで予約する場合のご注意</p>
            <p className="noteText">
          予約手続きの完了通知は、入力いただくメールアドレスに自動送信されます。<br/>
          お名前や、メールアドレス等誤入力いただいた個人情報の修正はできかねますので、正確にご入力ください。<br/>
          メールアドレスの誤入力や、お客様の受信設定によるメールの未着が発生しても、ご予約が完了している場合がございますのでご注意ください。<br/>
          予約取扱店舗よりご予約の確認のお電話をさせていただく場合がございます。電話番号は、日中ご連絡が取れる番号をご入力ください。<br/>
          予約の取り消しは、「マイページ（会員登録なしの予約）」より行ってください。
            </p>
          </div>
        </div>
        <div className="noteTexts">
          <div className="checkIcon">
            <img src="/dpp/img/icons/checkRed.svg" alt="" />
          </div>
          <div className="noteTextBody">
            <p className="noteTextTitle">予約に関するご注意</p>
            <p className="noteText">
        送信するボタンを押した段階では、予約は完了しておりません。承認メール受信後、本文に記載のURLをクリックして、予約手続きを進めてください。
            </p>
          </div>
        </div>
        <div className="actionsSup">旅行条件書内の<Textlink to={tripConditionUrl} outgoing>「22. 個人情報の取扱について」</Textlink>をご確認いただいた上で同意しますか？</div>
        <div className="actions">
          <div className="actionButton"><LinkButton buttonType="primary" onClick={handleAgree}>上記に同意の上送信する</LinkButton></div>
          <div className="actionButton"><LinkButton buttonType="navigateMid" onClick={handleBack}>会員認証に戻る</LinkButton></div>
        </div>
      </div>
      <ModalMail
        open={openModal}
        email={email}
        onClose={() => {
          setEmail('');
          setOpenModal(false);
        }}
      />
    </div>
  );
};

export default Mail;
